import { Grid, Typography } from "@mui/material";

export default function SectionTitle({title,subtitle,mt})
{
    return(
        <Grid container spacing={3} sx={{mt: mt || 1 ,mb:7}}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <Typography variant='h3' component='h1' sx={{textAlign:'center',fontWeight:'bold'}}>
                    {title}
                </Typography>
                <Typography variant='subtitle1' component='p' sx={{textAlign:'center'}}>
                    {subtitle}
                </Typography>
            </Grid>
        </Grid>
    )
}